import React from "react";
import { RouteObject } from "react-router-dom";
import { ApiClient } from "spry-react/utils/apiClient";

export function paymentHistoryRoutes(loaderApiClient: ApiClient): RouteObject {
  return {
    path: 'payment-history',
    lazy: async () => {
      const { PaymentHistoryPage } = await import('./paymentHistoryPage');
      return {
        element: <PaymentHistoryPage />,
      };
    },
  };
}

export class PaymentsUrls 
{
  public static history() {
    return "/payment-history"
  }
}